/* eslint-disable react/require-default-props,react/default-props-match-prop-types */
import CSSModules from 'react-css-modules';
import { injectIntl } from 'react-intl';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import format from 'date-fns-old/format';
import { DAY_FORMATTING_PATTERN } from '../../../constants/strings';

import styles from '../index.styl';

const MessageSeparatorView = ({
  date,
  intl: { formatMessage },
  left,
  hasBorder,
}) => (
  <p
    key={date}
    styleName={classNames('date', {
      'date--left': left,
      'date--has-border': hasBorder,
    })}
  >
    <time dateTime={date}>
      {format(date, formatMessage(DAY_FORMATTING_PATTERN))}
    </time>
  </p>
);

MessageSeparatorView.propTypes = {
  date: PropTypes.object.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
  left: PropTypes.bool,
  hasBorder: PropTypes.bool,
};

MessageSeparatorView.defaultProps = {
  date: '',
};

export default injectIntl(
  CSSModules(MessageSeparatorView, styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/Chat/components/MessageSeparatorView.jsx